import { useEffect, useState } from "react";
import { UserRound } from "lucide-react";
import { api } from "@/auth/AuthContext";

export const ProtectedBankPhoto = ({ photoId, alt, className = "", dataTestId = "bank-profile-photo" }) => {
  const [source, setSource] = useState("");
  useEffect(() => {
    let active = true; let objectUrl = "";
    if (!photoId) { setSource(""); return undefined; }
    api.get(`/mantab/bank/profile/photo/${photoId}`, { responseType: "blob" }).then(({ data }) => {
      if (!active) return; objectUrl = URL.createObjectURL(data); setSource(objectUrl);
    }).catch(() => { if (active) setSource(""); });
    return () => { active = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [photoId]);
  if (!source) return <span className={`bank-photo-fallback ${className}`} data-testid={`${dataTestId}-fallback`}><UserRound /></span>;
  return <img className={className} src={source} alt={alt} data-testid={dataTestId} />;
};